'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIntl = require('react-intl');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _baseBcReactComponent = require('@bibliocommons/base-bc-react-component');

var _baseBcReactComponent2 = _interopRequireDefault(_baseBcReactComponent);

require('../styles/UserStaffStamp.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var UserStaffStamp = function (_BcReactComponent) {
  _inherits(UserStaffStamp, _BcReactComponent);

  function UserStaffStamp() {
    _classCallCheck(this, UserStaffStamp);

    return _possibleConstructorReturn(this, (UserStaffStamp.__proto__ || Object.getPrototypeOf(UserStaffStamp)).apply(this, arguments));
  }

  _createClass(UserStaffStamp, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          inverse = _props.inverse;


      return _react2.default.createElement(
        'span',
        { className: (0, _classnames2.default)('cp-user-staff-stamp', className, { inverse: inverse }) },
        _react2.default.createElement(_reactIntl.FormattedMessage, { id: 'library_staff' })
      );
    }
  }]);

  return UserStaffStamp;
}(_baseBcReactComponent2.default);

UserStaffStamp.propTypes = {
  inverse: _react.PropTypes.bool
};

exports.default = UserStaffStamp;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-staff-stamp/lib/components/UserStaffStamp.component.js
// module id = 1558
// module chunks = 1